import dayjs from 'dayjs'

const ASAP_DAYS = 10

export function isBusinessDay(date) {
    const day = dayjs(date).day()
    return day !== 0 && day !== 6
}

export function firstBusinessDayOnOrAfter(date) {
    let current = dayjs(date).startOf('day')

    while (!isBusinessDay(current)) {
        current = current.add(1, 'day')
    }

    return current
}

export function addBusinessDays(date, businessDaysToAdd) {
    let current = dayjs(date).startOf('day')
    let added = 0

    while (added < businessDaysToAdd) {
        current = current.add(1, 'day')
        if (isBusinessDay(current)) {
            added += 1
        }
    }

    return current
}

export function getEligibleDateRange(timeframe, createdAt) {
    const created = dayjs(createdAt)

    switch (timeframe) {
        case 'asap': {
            const start = firstBusinessDayOnOrAfter(created)
            return { start: start.startOf('day'), end: created.add(ASAP_DAYS, 'day').endOf('day') }
        }
        case 'in24to48hours':
            return {
                start: created.add(24, 'hour'),
                end: created.add(48, 'hour'),
            }
        case 'within7days': {
            const start = firstBusinessDayOnOrAfter(created)
            const end = addBusinessDays(start, 6).endOf('day')
            return { start: start.startOf('day'), end }
        }
        default:
            return null
    }
}

export function isDateEligible(date, timeframe, createdAt) {
    if (!timeframe || !createdAt) {
        return true
    }

    const current = dayjs(date).startOf('day')

    if (!isBusinessDay(current)) {
        return false
    }

    if (timeframe === 'in24to48hours') {
        const created = dayjs(createdAt)
        const rangeStart = created.add(24, 'hour')
        const rangeEnd = created.add(48, 'hour')
        const dayStart = current.startOf('day')
        const dayEnd = current.endOf('day')

        return dayStart.isBefore(rangeEnd) && dayEnd.isAfter(rangeStart)
    }

    const range = getEligibleDateRange(timeframe, createdAt)

    if (!range) {
        return true
    }

    return !current.isBefore(range.start, 'day') && !current.isAfter(range.end, 'day')
}

export function isSlotEligible(slotDateTime, timeframe, createdAt) {
    if (!timeframe || !createdAt) {
        return true
    }

    const slot = dayjs(slotDateTime)
    const created = dayjs(createdAt)

    if (!isBusinessDay(slot)) {
        return false
    }

    if (!slot.isAfter(created)) {
        return false
    }

    if (timeframe === 'in24to48hours') {
        const rangeStart = created.add(24, 'hour')
        const rangeEnd = created.add(48, 'hour')

        return slot.isAfter(rangeStart) && (slot.isBefore(rangeEnd) || slot.isSame(rangeEnd))
    }

    if (timeframe === 'asap') {
        const start = firstBusinessDayOnOrAfter(created)
        const end = created.add(ASAP_DAYS, 'day').endOf('day')

        return !slot.isBefore(start, 'day') && !slot.isAfter(end)
    }

    if (timeframe === 'within7days') {
        const start = firstBusinessDayOnOrAfter(created)
        const end = addBusinessDays(start, 6).endOf('day')

        return !slot.isBefore(start, 'day') && !slot.isAfter(end)
    }

    return true
}
